import * as tslib_1 from "tslib";
/* tslint:disable:template-cyclomatic-complexity max-file-line-count */
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { DataDictionaryApi } from '../../api/data-dictionary-api';
import { GisToolsApi } from '../../api/gis-tools-api';
import { ESRI } from '../../esri-loader-util';
import { BooleanConverter, InputConverter } from '../../inputConverter';
import { keys } from '../../keys';
import { DocumentService } from '../../services/document.service';
import { LayerService } from '../../services/layer.service';
import { StorageService } from '../../services/storage.service';
import { ToSqlStringService } from '../../services/to-sql-string.service';
import { isPointGeometry, LogLevel } from '../../types';
import { BaseComponent } from '../base.component';
var urlMaxLength = 2048;
var Graphic;
var IdentifyComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IdentifyComponent, _super);
    function IdentifyComponent(_vcr, layerService, documentService, toSqlStringService, cdr, dataDictionaryApi, gisToolsApi, LoggingService, userSettingsService, authService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.documentService = documentService;
        _this.toSqlStringService = toSqlStringService;
        _this.cdr = cdr;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.gisToolsApi = gisToolsApi;
        _this.LoggingService = LoggingService;
        _this.userSettingsService = userSettingsService;
        _this.DEFAULT_TOLERANCE = 10000;
        _this._showIdentify = false;
        _this.showNearbyAssets = false;
        _this.showNearbyAssetsBtn = false;
        _this.enableNearbyMapMode = false;
        _this.showShowAll = true;
        _this.nearbyActiveChange = new EventEmitter();
        _this.enableBuffer = true;
        _this.highlightColor = 'rgba(125, 247, 229, 0.75)';
        _this.multiselectHighlightColor = 'rgba(250, 242, 10, 0.75)';
        _this.highlightMarkerSize = 12;
        _this.highlightLineWidth = 3;
        _this.reset = function () {
            _this.resetIdentify();
        };
        _this.loggedIn = false;
        _this.isCwopaUser = false;
        _this.showAdditionalInformation = true;
        _this.areChildTablesDisplayed = false;
        _this.parentIdToChildTableDict = new Map();
        _this.baseParentIdDict = new Map();
        _this.metaTableColumnsDict = new Map();
        _this.tableIdToTableDictionary = {};
        _this.updateStorage = true;
        _this._showAll = false;
        _this.bufferFeature = new EventEmitter();
        _this.identifiedCRS = new EventEmitter();
        _this.featureUpdated = new EventEmitter();
        _this.multiselectFeaturesUpdated = new EventEmitter();
        _this.docSourcesUpdated = new EventEmitter();
        _this.status = new EventEmitter();
        _this.openVideologEvent = new EventEmitter();
        _this._showVideologBtn = false;
        _this.openStreetViewEvent = new EventEmitter();
        _this._showStreetViewBtn = false;
        _this.findNearestSegment = false;
        _this.currentFeatureHasCRS = false;
        // TODO: There is a new process for finding these out for a given layer. We should use that. Li uses for filter.
        _this.countyDBNames = ['CTY_CODE'];
        _this.routeDBNames = ['ST_RT_NO'];
        _this.segmentDBNames = ['SEG_NO', 'SEG_BGN'];
        _this.offsetDBNames = ['OFFSET', 'OFFSET_BGN'];
        _this._sortType = 'database';
        _this.sortTypeOptions = ['alphabetical', 'database'];
        _this.sortTypeDisplayOptions = { alphabetical: 'Alphabetical', database: 'Database' };
        _this.enableCustom = false;
        _this.activate = function () {
            if (!_this.identifyHandler) {
                _this.identifyHandler = _this.mapView.on('click', function (event) {
                    _this.isMultiselectClick = event.native.ctrlKey;
                    // Cache this before it gets reset in case it's needed for handling multiple selection
                    _this.selectedFeatures = _this.features;
                    if (_this.isMultiselectClick && !_this.isMultiselectMode && _this.currentFeature != null) {
                        // Switching from single select to multiselect
                        _this.clearIdentifyHighlightLayer(false);
                        _this.isMultiselectMode = true;
                    }
                    else if (!_this.isMultiselectClick && _this.isMultiselectMode) {
                        // Switching from multiselect to single select
                        _this.clearIdentifyHighlightLayer(true);
                        _this.isMultiselectMode = false;
                    }
                    _this.featureUpdated.emit(null);
                    _this.docSourcesUpdated.emit(null);
                    _this.cdr.detectChanges();
                    if (_this.enableNearbyMapMode) {
                        var pointOfInterest = new Graphic({
                            geometry: {
                                type: 'point',
                                spatialReference: 3857,
                                latitude: event.mapPoint.latitude,
                                longitude: event.mapPoint.longitude
                            },
                            symbol: {
                                type: 'simple-marker'
                            }
                        });
                        _this.currentFeature = pointOfInterest;
                        _this.showNearbyAssets = true;
                        _this.showIdentify = true;
                    }
                    else {
                        _this.loading = true;
                        _this.status.emit('loading');
                        _this.showIdentify = false;
                        _this.showNearbyAssets = false;
                        _this.executeIdentifyTask(event.mapPoint);
                    }
                    _this.cdr.detectChanges();
                });
            }
        };
        _this.deactivate = function () {
            if (_this.identifyHandler) {
                _this.identifyHandler.remove();
                _this.identifyHandler = null;
            }
        };
        _this.refresh = function () {
            _this.executeIdentifyTask(_this.lastExecutePoint, _this.lastCurrentFeature);
        };
        _this.previousFeature = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasPreviousFeature) return [3 /*break*/, 2];
                        this.currentChildTable = null;
                        this.currentChildTableData = null;
                        this.currentFeatureIndex--;
                        return [4 /*yield*/, this.updateCurrentFeature()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.nextFeature = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasNextFeature) return [3 /*break*/, 2];
                        this.currentChildTable = null;
                        this.currentChildTableData = null;
                        this.currentFeatureIndex++;
                        return [4 /*yield*/, this.updateCurrentFeature()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.getHasPreviousFeature = function () {
            return _this.hasPreviousFeature;
        };
        _this.getHasNextFeature = function () {
            return _this.hasNextFeature;
        };
        _this.getFeatureCountAndIndex = function () {
            return [_this.features.length, _this.currentFeatureIndex];
        };
        _this.getCurrentFeature = function () {
            return _this.currentFeature;
        };
        _this.localStorageService = new StorageService();
        _this.registerEvent('featureUpdated', _this.featureUpdated);
        _this.registerEvent('multiselectFeaturesUpdated', _this.multiselectFeaturesUpdated);
        _this.registerEvent('docSourcesUpdated', _this.docSourcesUpdated);
        _this.localStorageService = new StorageService({ userSettingsService: userSettingsService, authService: authService });
        authService.user.subscribe(function (user) {
            _this.loggedIn = !!user;
        });
        authService.permissions.subscribe(function (permissions) {
            _this.isCwopaUser = permissions && permissions.includes('View CWOPA Data');
        });
        return _this;
    }
    Object.defineProperty(IdentifyComponent.prototype, "showIdentify", {
        get: function () {
            return this._showIdentify;
        },
        set: function (value) {
            this._showIdentify = value;
            if (!value) {
                this.clearIdentifyHighlightLayer(!this.isMultiselectClick);
                this.clearIdentifyHighlightLayer(this.isMultiselectClick);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IdentifyComponent.prototype, "columnSettingsStorageKey", {
        get: function () {
            var storageKey;
            if (this.currentFeature && this.currentFeature.layer) {
                var mapcoreProps = this.layerService.getSourceMapcoreProps(this.currentFeature.layer);
                var projectIdClause = this.toSqlStringService.getPetlProjectIdClauseIfPresent(mapcoreProps.parentId, mapcoreProps.query, mapcoreProps.isPETL);
                if (projectIdClause) {
                    // use a different storage key for PETL layers
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'petl-' + projectIdClause.value);
                }
                else if (!mapcoreProps.isExternal) {
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'table-' + this.getTableId(mapcoreProps).toString());
                }
                else {
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'ex-' + mapcoreProps.hashedUrl);
                }
            }
            return storageKey;
        } //**TODO Handle non-mapcore layers**
        ,
        enumerable: true,
        configurable: true
    });
    IdentifyComponent.prototype.getTableId = function (mapcoreProps) {
        if (mapcoreProps && mapcoreProps.tables && mapcoreProps.tables[0].id) {
            return mapcoreProps.tables[0].id;
        }
        return 0;
    };
    Object.defineProperty(IdentifyComponent.prototype, "showAll", {
        get: function () { return this._showAll; },
        set: function (val) {
            var _this = this;
            var change = this._showAll !== val;
            this._showAll = val;
            if (this.currentFeature != undefined) {
                (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.updateStorage) return [3 /*break*/, 4];
                                return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                            case 1:
                                if (!_a.sent()) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'showAll', this._showAll)];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                this.createColumnSettingsStorage();
                                _a.label = 4;
                            case 4:
                                this.cdr.detectChanges();
                                if (!change) return [3 /*break*/, 6];
                                return [4 /*yield*/, this.updateCurrentFeature()];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); })();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IdentifyComponent.prototype, "showVideologBtn", {
        get: function () { return this._showVideologBtn; },
        set: function (val) { this._showVideologBtn = val; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IdentifyComponent.prototype, "showStreetViewBtn", {
        get: function () { return this._showStreetViewBtn; },
        set: function (val) { this._showStreetViewBtn = val; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IdentifyComponent.prototype, "sortType", {
        get: function () { return this._sortType; },
        set: function (val) {
            var _this = this;
            var change = this._sortType !== val;
            this._sortType = val;
            if (this.currentFeature != undefined) {
                (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.updateStorage) return [3 /*break*/, 5];
                                return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                            case 1:
                                if (!_a.sent()) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'sortBy', this._sortType)];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, this.createColumnSettingsStorage()];
                            case 4:
                                _a.sent();
                                _a.label = 5;
                            case 5:
                                if (!(this._sortType === 'custom')) return [3 /*break*/, 7];
                                return [4 /*yield*/, this.isCustomSortChanged()];
                            case 6:
                                change = _a.sent();
                                _a.label = 7;
                            case 7:
                                if (!change) return [3 /*break*/, 9];
                                return [4 /*yield*/, this.sortFeature()];
                            case 8:
                                _a.sent();
                                _a.label = 9;
                            case 9: return [2 /*return*/];
                        }
                    });
                }); })();
            }
        },
        enumerable: true,
        configurable: true
    });
    IdentifyComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, error_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _c.sent();
                        this.activate();
                        return [4 /*yield*/, Promise.all([ESRI.Graphic])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 1]), Graphic = _a[0];
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.docSource) {
                    this.docSource.nativeElement.addEventListener('docSourcesUpdated', function (docSources) {
                        _this.docSourcesUpdated.emit(docSources);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    IdentifyComponent.prototype.createColumnSettingsStorage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var columnStorageSettings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        columnStorageSettings = { showAll: this.showAll, sortBy: this.sortType, settings: [], enableCustom: this.enableCustom };
                        return [4 /*yield*/, this.localStorageService.set(this.columnSettingsStorageKey, columnStorageSettings)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.openNearbyAssets = function () {
        this.showNearbyAssets = true;
    };
    IdentifyComponent.prototype.executeIdentifyTask = function (mapPoint, selectedFeatureOverride) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, lastFeature, layerOrder_1, allIndentifyResults, allFeatureResults, fieldDictionary_1, metaTableIds, allFeatureResults_1, allFeatureResults_1_1, featureResult, mapcoreProps, results, sortAttributes_1, collectAttributes_1, collectedAttributes, newFeatures, results_1, results_1_1, feature, attributes, firstFeature_1, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        lastFeature = this.currentFeature;
                        this.currentFeature = null;
                        this.resetIdentify();
                        return [4 /*yield*/, this.updateShowAllValue()];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this.updateSortByValue()];
                    case 2:
                        _c.sent();
                        this.lastExecutePoint = mapPoint;
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 9, 10, 11]);
                        layerOrder_1 = this.mapView.map.allLayers.toArray().map(function (layer) { return layer.id; });
                        return [4 /*yield*/, Promise.all([
                                this.identifyGraphicsLayers(this.mapView.toScreen(mapPoint)),
                                this.layerService.identifyMapImagelayers(mapPoint, true, true),
                                this.identifyUrlFeatureLayers(mapPoint)
                            ])];
                    case 4:
                        allIndentifyResults = _c.sent();
                        allFeatureResults = allIndentifyResults.map(function (r) { return r.features; }).flat().sort(function (a, b) {
                            var aIndex = layerOrder_1.findIndex(function (id) { return id === a.layer.id; });
                            var bIndex = layerOrder_1.findIndex(function (id) { return id === b.layer.id; });
                            if (aIndex < bIndex) {
                                return 1;
                            }
                            else if (aIndex > bIndex) {
                                return -1;
                            }
                            return 0;
                        });
                        fieldDictionary_1 = allIndentifyResults.reduce(function (prev, curr) { return (tslib_1.__assign({}, prev, curr.fields)); }, {});
                        metaTableIds = new Set();
                        try {
                            for (allFeatureResults_1 = tslib_1.__values(allFeatureResults), allFeatureResults_1_1 = allFeatureResults_1.next(); !allFeatureResults_1_1.done; allFeatureResults_1_1 = allFeatureResults_1.next()) {
                                featureResult = allFeatureResults_1_1.value;
                                if (featureResult.layer) {
                                    mapcoreProps = this.layerService.getSourceMapcoreProps(featureResult.layer);
                                    if (mapcoreProps && mapcoreProps.columns && !mapcoreProps.columns.some(function (c) { return !!c.domainValues; }) && mapcoreProps.metaTableId) {
                                        metaTableIds.add(mapcoreProps.metaTableId);
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (allFeatureResults_1_1 && !allFeatureResults_1_1.done && (_a = allFeatureResults_1.return)) _a.call(allFeatureResults_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, Promise.all(Array.from(metaTableIds).map(function (metaTableId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var dictionary;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!this.metaTableColumnsDict.has(metaTableId)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(metaTableId)];
                                        case 1:
                                            dictionary = _a.sent();
                                            if (dictionary && dictionary.length) {
                                                this.metaTableColumnsDict.set(metaTableId, dictionary);
                                            }
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 5:
                        _c.sent();
                        results = allFeatureResults.map(function (result) {
                            var e_3, _a;
                            var columns = [];
                            if (result.layer) {
                                var mapcoreProps = _this.layerService.getSourceMapcoreProps(result.layer);
                                if (mapcoreProps && mapcoreProps.columns) {
                                    if (mapcoreProps.metaTableId) {
                                        var dictionary = _this.metaTableColumnsDict.get(mapcoreProps.metaTableId);
                                        if (dictionary) {
                                            var _loop_1 = function (column) {
                                                var matchingColumn = mapcoreProps.columns.find(function (c) { return c.name.toLowerCase().trim() === column.columnName.toLowerCase().trim(); });
                                                if (matchingColumn) {
                                                    matchingColumn.domainValues = column.domainValues;
                                                }
                                            };
                                            try {
                                                for (var dictionary_1 = tslib_1.__values(dictionary), dictionary_1_1 = dictionary_1.next(); !dictionary_1_1.done; dictionary_1_1 = dictionary_1.next()) {
                                                    var column = dictionary_1_1.value;
                                                    _loop_1(column);
                                                }
                                            }
                                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                            finally {
                                                try {
                                                    if (dictionary_1_1 && !dictionary_1_1.done && (_a = dictionary_1.return)) _a.call(dictionary_1);
                                                }
                                                finally { if (e_3) throw e_3.error; }
                                            }
                                        }
                                    }
                                    columns = mapcoreProps.columns;
                                }
                            }
                            var layerId = result.layer.id;
                            var fields = fieldDictionary_1[layerId];
                            var retVal = tslib_1.__assign({}, result, { attributes: Object.entries(result.attributes).reduce(function (accu, _a) {
                                    var _b = tslib_1.__read(_a, 2), k = _b[0], v = _b[1];
                                    var field;
                                    if (fields) {
                                        field = fields.find(function (f) { return f.name === k; });
                                    }
                                    var attribute = {
                                        columnName: k,
                                        displayName: k,
                                        value: v,
                                        dbOrder: accu.count,
                                        type: field ? field.type : undefined
                                    };
                                    if (columns.length > 0) {
                                        var foundColumn = columns.find(function (x) { return x.name.toUpperCase() === k; });
                                        if (foundColumn) {
                                            attribute.dbOrder = foundColumn.databaseColumnOrder;
                                            attribute.displayName = foundColumn.alias || foundColumn.name;
                                            if (foundColumn.domainValues) {
                                                var foundDomainValue = void 0;
                                                if (typeof attribute.value === 'number') {
                                                    foundDomainValue = foundColumn.domainValues.find(function (dv) { return parseFloat(dv.codeValue.toString()) === attribute.value; });
                                                }
                                                else {
                                                    foundDomainValue = foundColumn.domainValues.find(function (dv) { return dv.codeValue === attribute.value; });
                                                }
                                                if (foundDomainValue) {
                                                    attribute.domainValue = foundDomainValue.codeValue + " - " + foundDomainValue.shortDescription;
                                                }
                                            }
                                        }
                                    }
                                    accu.count++;
                                    accu.attributes.push(attribute);
                                    return accu;
                                }, { count: 0, attributes: [] }).attributes });
                            _this.setAttributeIsUrl(retVal);
                            return retVal;
                        });
                        this.clearIdentifyHighlightLayer(!this.isMultiselectClick);
                        this.clearIdentifyHighlightLayer(this.isMultiselectClick);
                        if (!(results.length > 0)) return [3 /*break*/, 7];
                        this.showIdentify = true;
                        window.addEventListener('itemInserted', function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.features = this.cloneFeatures(this.tempFeatures);
                                        this.updateStorage = false;
                                        this.updateSortByValue();
                                        return [4 /*yield*/, this.updateCurrentFeature()];
                                    case 1:
                                        _a.sent();
                                        this.updateStorage = true;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.features = results;
                        if (this.isMultiselectMode) {
                            sortAttributes_1 = function (a, b) { return a.columnName.localeCompare(b.columnName); };
                            collectAttributes_1 = function (f) { return JSON.stringify(f.attributes.sort(sortAttributes_1)); };
                            collectedAttributes = new Set(this.selectedFeatures.map(collectAttributes_1));
                            newFeatures = [];
                            try {
                                for (results_1 = tslib_1.__values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                                    feature = results_1_1.value;
                                    attributes = collectAttributes_1(feature);
                                    if (!collectedAttributes.has(attributes)) {
                                        newFeatures.push(feature);
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (results_1_1 && !results_1_1.done && (_b = results_1.return)) _b.call(results_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            this.features = Array.from(this.selectedFeatures);
                            if (newFeatures.length > 0) {
                                // Add the new features and highlight the top one
                                this.features = this.features.concat(newFeatures);
                                this.currentFeatureIndex = this.features.length - newFeatures.length;
                            }
                            else {
                                firstFeature_1 = collectAttributes_1(results[0]);
                                this.currentFeatureIndex = this.features.findIndex(function (f) { return collectAttributes_1(f) === firstFeature_1; });
                            }
                        }
                        else {
                            this.features = results;
                            this.currentFeatureIndex = 0;
                        }
                        this.tempFeatures = this.cloneFeatures(this.features);
                        if (selectedFeatureOverride) {
                            this.currentFeatureIndex = selectedFeatureOverride.lastFeatureIndex;
                            if (this.currentFeatureIndex >= this.features.length) {
                                this.currentFeatureIndex = this.features.length - 1;
                            }
                        }
                        return [4 /*yield*/, this.updateCurrentFeature()];
                    case 6:
                        _c.sent();
                        if (this.currentFeature === lastFeature && !this.isMultiselectClick) {
                            this.showNearbyAssets = true;
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        if (!this.showNearbyAssets) {
                            this.showIdentify = false;
                            this.featureUpdated.emit(null);
                            this.docSourcesUpdated.emit(null);
                        }
                        _c.label = 8;
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        error_2 = _c.sent();
                        this.LoggingService.Log(error_2, LogLevel.Error);
                        return [3 /*break*/, 11];
                    case 10:
                        this.loading = false;
                        this.status.emit('loaded');
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.cloneFeatures = function (results) {
        if (results && results.length) {
            var featureClones = results.filter(function (result) {
                var featureInfo = result;
                return featureInfo;
            }).map(function (result) {
                var featureClone = {
                    geometry: result.geometry,
                    childTables: result.childTables,
                    isAggregate: result.isAggregate,
                    layer: result.layer,
                    layerName: result.layerName || result.layer.title,
                    popupTemplate: result.popupTemplate,
                    sourceLayer: result.sourceLayer,
                    symbol: result.symbol,
                    attributes: result.attributes,
                    visible: result.visible
                };
                return featureClone;
            }).filter(function (x) { return x !== undefined; });
            return featureClones;
        }
        else {
            return [];
        }
    };
    IdentifyComponent.prototype.identifyGraphicsLayers = function (screenPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, retVal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapView.hitTest(screenPoint)];
                    case 1:
                        response = _a.sent();
                        retVal = { features: [], fields: {} };
                        if (response.results.length) {
                            retVal.features = response.results.filter(function (result) {
                                var layer = result.graphic.layer;
                                return layer
                                    && (layer.type === 'graphics' || layer.source)
                                    && _this.layerService.layerIdentifyEnabled(layer)
                                    && layer.visible
                                    && layer.type !== 'feature';
                            }).map(function (result) {
                                var graphic = result.graphic.clone();
                                var graphicClone = {
                                    attributes: tslib_1.__assign({}, graphic.attributes),
                                    geometry: graphic.geometry.clone(),
                                    layer: graphic.layer,
                                    layerName: graphic.layer.title
                                };
                                if (!graphicClone.attributes) {
                                    graphic.attributes = {};
                                }
                                switch (graphicClone.geometry.type) {
                                    case 'point':
                                        graphicClone.attributes.LATITUDE = graphic.geometry.latitude;
                                        graphicClone.attributes.LONGITUDE = graphic.geometry.longitude;
                                        break;
                                    case 'polyline':
                                        //TODO
                                        break;
                                    default:
                                        break;
                                }
                                return graphicClone;
                            }).filter(function (x) { return x !== undefined; });
                        }
                        return [2 /*return*/, retVal];
                }
            });
        });
    };
    IdentifyComponent.prototype.identifyUrlFeatureLayers = function (mapPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, featureLayers, responses;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            geometry: mapPoint,
                            spatialRelationship: 'intersects',
                            returnGeometry: true,
                            returnQueryGeometry: true,
                            outFields: ['*']
                        };
                        this.layerService.setTolerance(query);
                        featureLayers = this.mapView.map.allLayers.filter(function (layer) {
                            return layer.type === 'feature'
                                && _this.layerService.layerIdentifyEnabled(layer)
                                && layer.visible;
                        });
                        return [4 /*yield*/, Promise.all(featureLayers.map(function (layer) {
                                var layerQuery = tslib_1.__assign({}, query);
                                layerQuery.where = _this.toSqlStringService.getSql(layer.mapcoreProps.query);
                                return layer.queryFeatures(layerQuery);
                            }).toArray())];
                    case 1:
                        responses = _a.sent();
                        return [2 /*return*/, responses.reduce(function (retVal, response) {
                                var _a;
                                (_a = retVal.features).push.apply(_a, tslib_1.__spread(response.features.map(function (feature) { return ({
                                    attributes: tslib_1.__assign({}, feature.attributes),
                                    geometry: feature.geometry ? feature.geometry.clone() : null,
                                    layer: feature.layer,
                                    layerName: feature.layer.title
                                }); })));
                                if (response.fields && response.features && response.features.length) {
                                    retVal.fields[response.features[0].layer.id] = response.fields;
                                }
                                return retVal;
                            }, { features: [], fields: {} })];
                }
            });
        });
    };
    IdentifyComponent.prototype.toggleCurrentChildTable = function (table) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.currentChildTable === table) {
                            this.currentChildTable = null;
                            this.currentChildTableData = null;
                        }
                        else {
                            this.currentChildTable = table;
                            this.currentChildTableDataIndex = 0;
                            this.updateCurrentChildTableData();
                        }
                        return [4 /*yield*/, this.sortFeature()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.previousChildTableData = function () {
        if (this.hasPreviousChildTableData) {
            this.currentChildTableDataIndex--;
            this.updateCurrentChildTableData();
        }
    };
    IdentifyComponent.prototype.nextChildTableData = function () {
        if (this.hasNextChildTableData) {
            this.currentChildTableDataIndex++;
            this.updateCurrentChildTableData();
        }
    };
    IdentifyComponent.prototype.updateShowAllValue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var settingsStorage;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentFeature != undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 1:
                        settingsStorage = _a.sent();
                        if (settingsStorage !== null) {
                            this.updateStorage = false;
                            this.showAll = settingsStorage.showAll;
                            this.updateStorage = true;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.updateSortByValue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var settingsStorage;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentFeature != undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 1:
                        settingsStorage = _a.sent();
                        if (settingsStorage !== null) {
                            this.updateStorage = false;
                            this.sortType = settingsStorage.sortBy ? settingsStorage.sortBy : 'database';
                            this.updateStorage = true;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.updateCurrentChildTableData = function () {
        this.currentChildTableData = Object.entries(this.currentChildTable.childTableData[this.currentChildTableDataIndex]);
        var attributes = this.currentChildTableData.map(function (_a) {
            var _b = tslib_1.__read(_a, 2), columnName = _b[0], value = _b[1];
            return ({ columnName: columnName, displayName: columnName, value: value });
        });
        this.docSourceTable = { tableId: this.currentChildTable.tableId, attributes: attributes };
        var myIndex = this.currentChildTableData.findIndex(function (x) { return x[0] === 'DATA'; });
        if (myIndex !== -1) {
            this.currentChildTableData.splice(myIndex, 1);
        }
        this.hasPreviousChildTableData = this.currentChildTableDataIndex > 0;
        this.hasNextChildTableData = this.currentChildTableDataIndex < this.currentChildTable.childTableData.length - 1;
    };
    IdentifyComponent.prototype.updateCurrentFeature = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var settingsStorage, crs;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.features || this.currentFeatureIndex < 0 || this.features.length < this.currentFeatureIndex) {
                            return [2 /*return*/];
                        }
                        this.hasPreviousFeature = this.currentFeatureIndex > 0;
                        this.hasNextFeature = this.currentFeatureIndex < this.features.length - 1;
                        this.areChildTablesDisplayed = false;
                        this.currentChildTable = null;
                        this.showAdditionalInformation = true;
                        this.currentFeature = this.features[this.currentFeatureIndex];
                        this.lastCurrentFeature = { lastFeatureIndex: this.currentFeatureIndex, lastFeaturesLength: this.features.length };
                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 1:
                        settingsStorage = _a.sent();
                        if (settingsStorage && settingsStorage.enableCustom) {
                            this.enableCustom = true;
                        }
                        else {
                            this.enableCustom = false;
                        }
                        return [4 /*yield*/, this.getCRSValuesFromCurrentFeature()];
                    case 2:
                        crs = _a.sent();
                        this.currentFeatureHasCRS = crs !== undefined;
                        this.featureUpdated.emit(this.currentFeature);
                        this.identifiedCRS.emit(crs);
                        if (this.isMultiselectClick) {
                            this.multiselectFeaturesUpdated.emit(this.features);
                        }
                        if (!(this.currentFeature && this.currentFeature.layer !== undefined)) return [3 /*break*/, 5];
                        if (this.enableCustom) {
                            this.sortTypeDisplayOptions = { alphabetical: 'Alphabetical', database: 'Database', custom: 'Custom' };
                            this.sortTypeOptions = ['alphabetical', 'database', 'custom'];
                        }
                        return [4 /*yield*/, this.updateShowAllValue()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.updateSortByValue()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        //remove custom sort for non-system layers
                        this.sortTypeDisplayOptions = { alphabetical: 'Alphabetical', database: 'Database' };
                        this.sortTypeOptions = ['alphabetical', 'database'];
                        _a.label = 6;
                    case 6: return [4 /*yield*/, this.updateFieldVisibility()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, this.sortFeature()];
                    case 8:
                        _a.sent();
                        this.highlightIdentifyGraphics();
                        this.setMapRmsObjectFromSelectedFeature();
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.updateFieldVisibility = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, e_5, _b, e_6, _c, _d, _e, attr, settingsStorage, shownColumns, shownColumns_1, shownColumns_1_1, c, _loop_2, _f, _g, attr;
            return tslib_1.__generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (this.showAll) {
                            try {
                                for (_d = tslib_1.__values(this.currentFeature.attributes.filter(function (attribute) { return attribute.hide; })), _e = _d.next(); !_e.done; _e = _d.next()) {
                                    attr = _e.value;
                                    attr.hide = false;
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                            //force update shown grid, changes won't display otherwise
                            this.cdr.detectChanges();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 1:
                        settingsStorage = _h.sent();
                        if (settingsStorage) {
                            shownColumns = settingsStorage.settings;
                        }
                        if (!shownColumns || !shownColumns.length) {
                            return [2 /*return*/];
                        }
                        try {
                            //uppercase all column names in shownColumns to match how field represents the column names
                            for (shownColumns_1 = tslib_1.__values(shownColumns), shownColumns_1_1 = shownColumns_1.next(); !shownColumns_1_1.done; shownColumns_1_1 = shownColumns_1.next()) {
                                c = shownColumns_1_1.value;
                                c.name = c.name.toUpperCase();
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (shownColumns_1_1 && !shownColumns_1_1.done && (_b = shownColumns_1.return)) _b.call(shownColumns_1);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        _loop_2 = function (attr) {
                            if (shownColumns.findIndex(function (shownColumn) { return shownColumn.visible && shownColumn.name === attr.columnName; }) === -1) {
                                attr.hide = true;
                            }
                            else if (attr.hide) {
                                attr.hide = false;
                            }
                        };
                        try {
                            //filter feature attributes to only include attributes that match a visible column OR
                            //are a reserved column
                            for (_f = tslib_1.__values(this.currentFeature.attributes), _g = _f.next(); !_g.done; _g = _f.next()) {
                                attr = _g.value;
                                _loop_2(attr);
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        //force update shown grid, changes won't display otherwise
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.setAttributeIsUrl = function (feature) {
        var e_7, _a;
        if (feature && feature.attributes) {
            try {
                for (var _b = tslib_1.__values(feature.attributes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var attribute = _c.value;
                    if (attribute && attribute.value && this.isUrl(attribute.value) && !(attribute.type === 'download-url' || attribute.type === 'open-url')) {
                        attribute.type = 'open-url';
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
    };
    IdentifyComponent.prototype.setMapRmsObjectFromSelectedFeature = function () {
        if (this.currentFeature) {
            var rms = null;
            var mapcoreProps = this.layerService.getSourceMapcoreProps(this.currentFeature.layer);
            if (mapcoreProps && mapcoreProps.columns) {
                var columns = mapcoreProps.columns;
                var countyColumn = this.getMatchingColumn(columns, 'countyCode');
                var stateRouteColumn = this.getMatchingColumn(columns, 'routeNumber');
                var segBgnColumn = this.getMatchingColumn(columns, 'segBgn');
                var params = '';
                if (countyColumn) {
                    var attributes = this.currentFeature.attributes;
                    rms = { countyCode: this.getMathingFeatureValue(attributes, countyColumn.name) };
                    params += 'cn=' + rms.countyCode;
                    if (stateRouteColumn) {
                        rms.stateRoute = this.getMathingFeatureValue(attributes, stateRouteColumn.name);
                        params += '&rt=' + rms.stateRoute;
                    }
                    if (segBgnColumn) {
                        rms.segmentBegin = this.getMathingFeatureValue(attributes, segBgnColumn.name);
                        params += '&sg=' + rms.segmentBegin;
                    }
                }
                else {
                    rms = null;
                }
                if (!this.mapView.map.mapcoreProps) {
                    this.mapView.map.mapcoreProps = {};
                }
                this.mapView.map.mapcoreProps.rms = rms;
                if (rms) {
                    this.mapView.map.mapcoreProps.rms.params = params;
                }
            }
        }
    };
    IdentifyComponent.prototype.getMatchingColumn = function (columns, name) {
        var foundArray = columns.filter(function (x) { return x.columnIdentifier && x.columnIdentifier.name === name; });
        if (foundArray.length > 0) {
            return foundArray[0];
        }
        return null;
    };
    IdentifyComponent.prototype.getMathingFeatureValue = function (attriubutes, columnName) {
        var foundArray = attriubutes.filter(function (x) { return x.columnName === columnName; });
        if (foundArray.length > 0) {
            return foundArray[0].value;
        }
        return null;
    };
    IdentifyComponent.prototype.clearIdentifyHighlightLayer = function (multiselect) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!multiselect) return [3 /*break*/, 3];
                        if (this.multiIdentifyHighlightLayer) {
                            this.addLayerIfMissing(this.multiIdentifyHighlightLayer);
                            this.multiIdentifyHighlightLayer.removeAll();
                        }
                        if (!(this.multiIdentifyHighlightLayer == undefined)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({
                                title: 'Multiselect identify',
                                listMode: 'hide'
                            }, {
                                hideInLegend: true,
                                identifyEnabled: false
                            })];
                    case 1:
                        _a.multiIdentifyHighlightLayer = _c.sent();
                        _c.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        if (this.identifyHighlightLayer) {
                            this.addLayerIfMissing(this.identifyHighlightLayer);
                            this.identifyHighlightLayer.removeAll();
                        }
                        if (!(this.identifyHighlightLayer == undefined)) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({
                                title: 'Identify',
                                listMode: 'hide'
                            }, {
                                hideInLegend: true,
                                identifyEnabled: false
                            })];
                    case 4:
                        _b.identifyHighlightLayer = _c.sent();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.addLayerIfMissing = function (layer) {
        if (!this.mapView.map.findLayerById(layer.id)) {
            this.mapView.map.add(layer);
        }
    };
    IdentifyComponent.prototype.highlightIdentifyGraphics = function () {
        var _this = this;
        this.clearIdentifyHighlightLayer(this.isMultiselectMode).then(function () {
            var e_8, _a;
            if (_this.isMultiselectMode) {
                _this.layerService.moveLayerToTheTop(_this.multiIdentifyHighlightLayer);
                try {
                    for (var _b = tslib_1.__values(_this.features.slice().reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var feature = _c.value;
                        if (feature.geometry.type !== 'point' || feature === _this.currentFeature) {
                            continue;
                        }
                        _this.highlightSingleIdentifyGraphics(_this.multiIdentifyHighlightLayer, feature, _this.multiselectHighlightColor);
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
                if (_this.currentFeature) {
                    _this.highlightSingleIdentifyGraphics(_this.multiIdentifyHighlightLayer, _this.currentFeature, _this.highlightColor);
                }
            }
            else {
                _this.layerService.moveLayerToTheTop(_this.identifyHighlightLayer);
                _this.highlightSingleIdentifyGraphics(_this.identifyHighlightLayer, _this.currentFeature, _this.highlightColor);
            }
        });
    };
    IdentifyComponent.prototype.highlightSingleIdentifyGraphics = function (layer, feature, highlightColor) {
        if (feature && feature.geometry) {
            var highlightGeometry = feature.geometry;
            var highlightSymbol = void 0;
            if (feature.symbol) {
                highlightSymbol = feature.symbol;
            }
            else {
                switch (feature.geometry.type) {
                    case 'point':
                        highlightSymbol = { type: 'simple-marker', size: this.highlightMarkerSize, outline: { color: this.highlightColor } };
                        break;
                    case 'polyline':
                        highlightSymbol = { type: 'simple-line', width: this.highlightLineWidth };
                        break;
                    case 'polygon':
                        highlightSymbol = { type: 'simple-fill' };
                        break;
                    default:
                        highlightSymbol = { type: 'simple-marker', size: this.highlightMarkerSize };
                        break;
                }
            }
            highlightSymbol.color = highlightColor;
            layer.add(new Graphic({
                geometry: highlightGeometry,
                symbol: highlightSymbol
            }));
        }
    };
    IdentifyComponent.prototype.sortFeature = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, settingsStorage, shownColumns_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.currentFeature) {
                            return [2 /*return*/];
                        }
                        _a = this.sortType;
                        switch (_a) {
                            case 'alphabetical': return [3 /*break*/, 1];
                            case 'database': return [3 /*break*/, 2];
                            case 'custom': return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        this.currentFeature.attributes.sort(function (a, b) {
                            if (a.displayName < b.displayName) {
                                return -1;
                            }
                            if (a.displayName > b.displayName) {
                                return 1;
                            }
                            return 0;
                        });
                        return [3 /*break*/, 6];
                    case 2:
                        this.currentFeature.attributes.sort(function (a, b) {
                            if (a.dbOrder < b.dbOrder) {
                                return -1;
                            }
                            if (a.dbOrder > b.dbOrder) {
                                return 1;
                            }
                            return 0;
                        });
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 4:
                        settingsStorage = _b.sent();
                        shownColumns_2 = settingsStorage.settings;
                        this.currentFeature.attributes.sort(function (a, b) { return (shownColumns_2.findIndex(function (c) { return c.name.toUpperCase() === a.columnName.toUpperCase(); }) -
                            shownColumns_2.findIndex(function (c) { return c.name.toUpperCase() === b.columnName.toUpperCase(); })); });
                        return [3 /*break*/, 6];
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.hideIdentify = function () {
        this.showIdentify = false;
        this.isMultiselectMode = false;
        window.removeEventListener('itemInserted', function () { });
        this.featureUpdated.emit(null);
        this.docSourcesUpdated.emit(null);
        this.resetIdentify();
        this.clearIdentifyHighlightLayer(true);
        this.clearIdentifyHighlightLayer(false);
        this.multiIdentifyHighlightLayer.removeAll();
        this.cdr.detectChanges();
    };
    IdentifyComponent.prototype.showChildTables = function (currentFeature) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var childTables, parentQuery_1, childTablePromises, error_3;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.areChildTablesDisplayed = !this.areChildTablesDisplayed;
                        childTables = currentFeature.childTables;
                        if (!(this.areChildTablesDisplayed && childTables)) return [3 /*break*/, 2];
                        if (!(childTables.filter(function (x) { return x.childTableData; }).length === 0)) return [3 /*break*/, 2];
                        this.loading = true;
                        parentQuery_1 = currentFeature.sourceLayer.parent.mapcoreProps.query;
                        childTablePromises = childTables.map(function (childTable) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var e_9, _a, tablesResult, childColumnKeys, parentKeys, paddingField, objIdFields_1, paddingObjectIdField, index, attributes, attributes_1, attributes_1_1, attribute, fieldNames_1, queryFilter, childTableDataValue, fieldValues;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        childTable.childTableData = [];
                                        if (!!this.tableIdToTableDictionary[childTable.tableId]) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.layerService.getLayerChildTable(childTable.layerId, childTable.tableId, 'id name columns{name dataType}')];
                                    case 1:
                                        tablesResult = _b.sent();
                                        if (tablesResult.length > 0) {
                                            this.tableIdToTableDictionary[childTable.tableId] = tablesResult[0];
                                        }
                                        _b.label = 2;
                                    case 2:
                                        if (this.tableIdToTableDictionary[childTable.tableId]) {
                                            childTable.table = this.tableIdToTableDictionary[childTable.tableId];
                                        }
                                        if (!childTable.table) return [3 /*break*/, 4];
                                        childColumnKeys = childTable.childParentKeyColumnName.replaceAll(' ', '').split('||');
                                        parentKeys = childTable.parentPrimaryKeyColumnName.split('||');
                                        paddingField = parentKeys.filter(function (x) { return x.toUpperCase().includes('PAD'); })[0];
                                        objIdFields_1 = parentKeys.filter(function (x) { return (!x.includes('\'')); });
                                        paddingObjectIdField = '';
                                        if (paddingField) {
                                            index = paddingField.indexOf('(');
                                            paddingObjectIdField = paddingField.substr(index + 1, paddingField.length - paddingField.indexOf(','));
                                            objIdFields_1.push(paddingObjectIdField);
                                        }
                                        attributes = currentFeature.attributes.filter(function (x) { return objIdFields_1.map(function (y) { return y.trim(); }).indexOf(x.columnName) > -1; });
                                        try {
                                            for (attributes_1 = tslib_1.__values(attributes), attributes_1_1 = attributes_1.next(); !attributes_1_1.done; attributes_1_1 = attributes_1.next()) {
                                                attribute = attributes_1_1.value;
                                                if (paddingField) {
                                                    if (paddingObjectIdField) {
                                                        parentKeys[parentKeys.indexOf(paddingField)] = ("" + paddingField.replace(paddingObjectIdField, attribute.value.toString()));
                                                    }
                                                }
                                                else {
                                                    parentKeys[parentKeys.map(function (y) { return y.trim(); }).indexOf(attribute.columnName)] = ("" + attribute.value);
                                                }
                                            }
                                        }
                                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                                        finally {
                                            try {
                                                if (attributes_1_1 && !attributes_1_1.done && (_a = attributes_1.return)) _a.call(attributes_1);
                                            }
                                            finally { if (e_9) throw e_9.error; }
                                        }
                                        fieldNames_1 = childTable.table.childTables[0].columns.map(function (col) { return col.name; });
                                        if (!parentKeys) return [3 /*break*/, 4];
                                        queryFilter = this.buildQueryFilter(parentKeys, childColumnKeys);
                                        if (parentQuery_1.childTableRecord && childTable.tableId === parentQuery_1.childTableRecord.id) {
                                            queryFilter.subqueries.push(parentQuery_1.childTableQuery);
                                        }
                                        return [4 /*yield*/, this.layerService.getLayerChildTableWithData(childTable.layerId, childTable.tableId, fieldNames_1, queryFilter)];
                                    case 3:
                                        childTableDataValue = _b.sent();
                                        fieldValues = childTableDataValue[0].childTables[0].data;
                                        if (fieldValues.length) {
                                            childTable.childTableData = fieldValues.map(function (values) {
                                                var keyValues = {};
                                                for (var i = 0; i < fieldNames_1.length; i++) {
                                                    keyValues[fieldNames_1[i]] = values[i];
                                                }
                                                return keyValues;
                                            });
                                        }
                                        this.combineChildTableData(childTable, childColumnKeys);
                                        if (childTable.orderKeyColumnName && childTable.childTableData.length > 1) {
                                            childTable.childTableData.sort(function (a, b) {
                                                var sortValueA = b[childTable.orderKeyColumnName];
                                                var sortValueB = a[childTable.orderKeyColumnName];
                                                if (sortValueA === null || sortValueB === null) {
                                                    return sortValueA === null ? (sortValueB === null ? 0 : -1) : 1;
                                                }
                                                else if (typeof sortValueA === 'number' || typeof sortValueB === 'number') {
                                                    return sortValueA === sortValueB ? 0 : (sortValueA > sortValueB ? 1 : -1);
                                                }
                                                else {
                                                    return sortValueA.toString().localeCompare(sortValueB.toString());
                                                }
                                            });
                                        }
                                        _b.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(childTablePromises)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.areChildTablesDisplayed) {
                            this.currentChildTable = null;
                            this.currentChildTableData = null;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        this.LoggingService.Log(error_3, LogLevel.Error);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.combineChildTableData = function (childTable, childColumnKeys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sources, docSources, field_1, combinedTableData_1, childDataKeyValues_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.documentService.getTableDocSources(childTable.tableId)];
                    case 1:
                        sources = _a.sent();
                        docSources = sources && sources.length ? sources[0].docSources : [];
                        if (docSources && docSources.length && docSources.length > 0 && docSources[0].fields) {
                            field_1 = JSON.parse(docSources[0].fields);
                            if (field_1.docCombineField) {
                                combinedTableData_1 = [];
                                childDataKeyValues_1 = new Set();
                                childTable.childTableData.forEach(function (childTableData) {
                                    var keyString = childColumnKeys.concat(field_1.docCombineField).map(function (key) { return childTableData[key]; }).join('|');
                                    if (!childDataKeyValues_1.has(keyString)) {
                                        combinedTableData_1.push(childTableData);
                                        childDataKeyValues_1.add(keyString);
                                    }
                                });
                                if (combinedTableData_1 && combinedTableData_1.length > 0 && childTable.childTableData && childTable.childTableData.length > 0 && childTable.childTableData.length > combinedTableData_1.length) {
                                    childTable.origialTableData = tslib_1.__spread(childTable.childTableData);
                                    childTable.childTableData = tslib_1.__spread(combinedTableData_1);
                                    childTable.hideDuplicateRecords = true;
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.buildQueryFilter = function (parentKeys, childKeys) {
        var query = {
            operator: 'AND',
            subqueries: []
        };
        if (parentKeys.length === childKeys.length) {
            for (var i = 0; i < parentKeys.length; i++) {
                query.subqueries.push({
                    field: childKeys[i].toString().trim(),
                    operator: '=',
                    value: parentKeys[i].toString().replaceAll('\'', '').trim()
                });
            }
        }
        return query;
    };
    IdentifyComponent.prototype.showDuplicateRecords = function (childTable) {
        childTable.childTableData = tslib_1.__spread(childTable.origialTableData);
        childTable.hideDuplicateRecords = false;
        this.currentChildTable = childTable;
        this.currentChildTableDataIndex = 0;
        this.updateCurrentChildTableData();
    };
    IdentifyComponent.prototype.resetIdentify = function () {
        this.loading = false;
        this.features = null;
        this.tempFeatures = null;
        this.currentFeature = null;
        this.currentChildTable = null;
        this.currentChildTableData = null;
        this.areChildTablesDisplayed = false;
        this.showAdditionalInformation = true;
        this.enableCustom = false;
        this.sortType = 'database';
        this.sortTypeOptions = ['alphabetical', 'database'];
        this.sortTypeDisplayOptions = { alphabetical: 'Alphabetical', database: 'Database' };
    };
    IdentifyComponent.prototype.openBufferWindow = function () {
        this.bufferFeature.emit(this.currentFeature.geometry);
    };
    IdentifyComponent.prototype.docSourcesUpdatedHandler = function () {
        if (this.docSource) {
            this.docSourcesUpdated.emit(this.docSource.docSources);
        }
    };
    IdentifyComponent.prototype.isUrl = function (value) {
        return value
            && typeof value === 'string'
            && value.length <= urlMaxLength
            && /^http[s]?:\/\/(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*(), ]|(?:%[0-9a-fA-F][0-9a-fA-F]))+$/.test(value.trim());
    };
    IdentifyComponent.prototype.onNearbyActiveChange = function (active) {
        if (!active && (!this.features || !this.features.length)) {
            this.hideIdentify();
        }
    };
    IdentifyComponent.prototype.onNearbyStatusChange = function (status) {
        this.status.emit(status);
    };
    IdentifyComponent.prototype.openVideolog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CRS;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.currentFeature) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCRSValuesFromCurrentFeature()];
                    case 1:
                        CRS = _a.sent();
                        this.openVideologEvent.emit(CRS);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.openStreetView = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CRS;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.currentFeature) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCRSValuesFromCurrentFeature()];
                    case 1:
                        CRS = _a.sent();
                        this.openStreetViewEvent.emit(CRS);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IdentifyComponent.prototype.openVideoLogWithCoordinates = function (coordinates) {
        this.openVideologEvent.emit({ coordinates: coordinates });
    };
    IdentifyComponent.prototype.openStreetViewWithCoordinates = function (coordinates) {
        this.openStreetViewEvent.emit({ coordinates: coordinates });
    };
    IdentifyComponent.prototype.getCRSValuesFromCurrentFeature = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CRS, allNames_1, foundAttributes, countyCode, stateRouteNumber, segmentNumber, offset, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentFeature && this.currentFeature.attributes)) return [3 /*break*/, 2];
                        allNames_1 = tslib_1.__spread(this.countyDBNames, this.routeDBNames, this.segmentDBNames, this.offsetDBNames);
                        foundAttributes = this.currentFeature.attributes.filter(function (attr) { return allNames_1.includes(attr.columnName.toUpperCase()); });
                        if (foundAttributes.length) {
                            countyCode = foundAttributes.find(function (attr) { return _this.countyDBNames.includes(attr.columnName.toUpperCase()); });
                            stateRouteNumber = foundAttributes.find(function (attr) { return _this.routeDBNames.includes(attr.columnName.toUpperCase()); });
                            segmentNumber = foundAttributes.find(function (attr) { return _this.segmentDBNames.includes(attr.columnName.toUpperCase()); });
                            offset = foundAttributes.find(function (attr) { return _this.offsetDBNames.includes(attr.columnName.toUpperCase()); });
                            CRS = {
                                countyCode: countyCode && countyCode.value ? countyCode.value.toString() : null,
                                stateRouteNumber: stateRouteNumber && stateRouteNumber.value ? stateRouteNumber.value.toString() : null,
                                segmentNumber: segmentNumber && segmentNumber.value ? segmentNumber.value.toString() : null,
                                offset: offset && offset.value ? offset.value.toString() : null
                            };
                        }
                        if (!(this.findNearestSegment
                            && isPointGeometry(this.currentFeature.geometry)
                            && (!CRS || !CRS.countyCode || !CRS.stateRouteNumber || !CRS.segmentNumber))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.gisToolsApi.getSegmentsClosestToLatLong(this.currentFeature.geometry.latitude, this.currentFeature.geometry.longitude, this.DEFAULT_TOLERANCE)];
                    case 1:
                        result = _a.sent();
                        if (result && result.length) {
                            CRS = {
                                countyCode: result[0].countyCode,
                                stateRouteNumber: result[0].stateRouteNumber,
                                segmentNumber: result[0].segmentNumber
                            };
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, CRS];
                }
            });
        });
    };
    IdentifyComponent.prototype.isCustomSortChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_10, _a, settingsStorage, count, _b, _c, localStorageCol, localStorageColName, currentColName;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 1:
                        settingsStorage = _d.sent();
                        if (settingsStorage !== null) {
                            count = 0;
                            try {
                                for (_b = tslib_1.__values(settingsStorage.settings), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    localStorageCol = _c.value;
                                    localStorageColName = localStorageCol.name;
                                    if (this.currentFeature.attributes[count] === undefined) {
                                        return [2 /*return*/, true];
                                    }
                                    currentColName = this.currentFeature.attributes[count].columnName;
                                    if (localStorageColName !== currentColName) {
                                        return [2 /*return*/, true];
                                    }
                                    count++;
                                }
                            }
                            catch (e_10_1) { e_10 = { error: e_10_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_10) throw e_10.error; }
                            }
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    IdentifyComponent.prototype.getLayerIdentifier = function (mapcoreProps) {
        var layerId = '';
        if (mapcoreProps) {
            if (mapcoreProps.id) {
                layerId = mapcoreProps.id.toString();
            }
            else if (mapcoreProps.idFromSavedLayer) {
                layerId = mapcoreProps.idFromSavedLayer.toString();
            }
            else if (mapcoreProps.parentId) {
                layerId = mapcoreProps.parentId.toString();
            }
        }
        return layerId;
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], IdentifyComponent.prototype, "showIdentify", null);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], IdentifyComponent.prototype, "showNearbyAssets", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], IdentifyComponent.prototype, "showNearbyAssetsBtn", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], IdentifyComponent.prototype, "enableNearbyMapMode", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], IdentifyComponent.prototype, "showShowAll", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], IdentifyComponent.prototype, "enableBuffer", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], IdentifyComponent.prototype, "findNearestSegment", void 0);
    return IdentifyComponent;
}(BaseComponent));
export { IdentifyComponent };
